import Api from "../commom/api";
import {DesignInterface} from "../commom/types";

const designAPI = async (evseID: string) => {
    const response = await Api.get<DesignInterface>('/evse/' + evseID + '/get-design/')
    return response.data
}

export {designAPI}
